import { Heading, HStack, Stack, } from "@chakra-ui/react";
import { generatePath, useNavigate, } from "react-router-dom";

import { LimitCard, } from "../LimitCard.tsx";
import { ILimitResponse, } from "../../../../../api";
import { RoutesMap, } from "../../../../../routes.tsx";

interface ILimitsBlockView {
  hasData: boolean;
  isLoading: boolean;
  data: ILimitResponse[] | undefined;
  showLimitPage?: boolean;
  cursorType?: "default" | "pointer";
}

export function LimitsBlockView({ hasData, isLoading, data, showLimitPage = true, cursorType = "pointer", }: ILimitsBlockView,) {
  const navigate = useNavigate();

  const onLimitCardClick = (id: string,) => {
    if (showLimitPage) {
      const url = generatePath(RoutesMap.limits.limit, { id, },);
      navigate(url,);
    }
  };

  return (
    <Stack spacing={2}>
      {hasData && (
        <HStack mb={2}>
          <Heading flex="1" size="md">
            Лимиты на рассрочки
          </Heading>
        </HStack>
      )}

      {(hasData || isLoading) && (
        <HStack
          spacing={2}
          overflowY="hidden"
          overflowX="scroll"
          py={2}
          px={4}
          mx={-4}
        >
          {hasData && data?.map(item => (
            <LimitCard
              key={item.id}
              name={item.name}
              availableAmount={item.availableAmount}
              totalAmount={item.totalAmount}
              onClick={() => { onLimitCardClick(item.id.toString(),); }}
              cursorType={cursorType}
            />
          ),)}

          {isLoading && (
            <>
              <LimitCard isLoading />
              <LimitCard isLoading />
              <LimitCard isLoading />
            </>
          )}
        </HStack>
      )}
    </Stack>
  );
}
